import styled from "styled-components";

export const WhatsAppIcon = styled.img`
  width: 65px;

  @media screen and (max-width: 479px) {
    width: 60px;
  }

  object-fit: cover;
`;

export const StyledLink = styled.a`
  width: 100%;
`;
